import React from 'react';
import {permissionObj} from '../../../Helpers/permission';
import AddDeviceModal from './Modal/AddDeviceModal';
import DeviceLogModal from '../Devices/Modals/DeviceLogModal';
import RemoveModal from '../../Modals/RemoveModal';
import Subtitle from "../../../components/Header/Subtitle";
import ButtonAction from "../../../components/buttons/ButtonAction";
import {TotalAccessApp} from "./Funtionality/TotalAccessApp";
import CustomTable from "../../../components/table/CustomTable";
import {DevicesTotalAccessTable} from "./Funtionality/DevicesTotalAccessTable";
import {TotalAccessMainApp} from "./Funtionality/TotalAccessMainApp";
import {AddIcon, TrashOutlineIcon} from '../../../components/buttons/IconButtons';

/**
 * @Email: azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 * @component
 * @param {Object} props - Component properties.
 * @param {Object} props.item - Data object containing device information.
 * @returns {JSX.Element} The rendered TotalAccessService component.
 */

const TotalAccessService = ({item, setModified}) => {

    const {
        t,
        DEV,
        permission,
        setShowLogModal,
        setModalShow,
        setDeleteDeviceShow,
        modalShow,
        showLogModal,
        deleteDeviceShow
    } = TotalAccessMainApp({item})

    const {tableId, searchId, thead, tbody} = TotalAccessApp({data:item})

    const {
        getActionsButtons,
        tableId1,
        searchId1,
        thead1,
        tbody1,
        selectedList,
        setSelectedList,
        isAllChecked,
        logDevice,
        handleDeleteAll,
        handleCheckboxChange
    } = DevicesTotalAccessTable({
        data: item?.devices,
        t, permission, DEV, setShowLogModal
    })

    return (
        <>
        <Subtitle name={'access_devices'}/>
            <CustomTable tableId={tableId}
                         searchId={searchId}
                         thead={thead}
                         tbody={tbody}
                         columnActions={false}
                         withoutHeight={true}
            />


            <Subtitle name={'devices'}>
                { ( DEV || permission?.includes(permissionObj?.WEB_ZONE_CREATE_DEVICES)) && (
                    <ButtonAction
                        id='btn_tadv_add'
                        name='add_new_devices'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={() => {
                            setModalShow(true);
                        }}
                        splitName={false}
                    />
                )}
                {(DEV || (permission?.includes(permissionObj?.WEB_ZONE_DELETE_DEVICES))) && (
                    <ButtonAction
                        id='btn_cp_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => {
                            setDeleteDeviceShow(true);
                        }}
                    />
                )}
            </Subtitle>

            <CustomTable tableId={tableId1}
                         searchId={searchId1}
                         thead={thead1}
                         tbody={tbody1}
                         checkbox={DEV || permission?.includes(permissionObj?.WEB_ZONE_DELETE_DEVICES)}
                         columnActions={true}
                         withoutHeight={true}
                         checkboxTitle={"de_/_select_all"}
                         isAllChecked={isAllChecked}
                         onChangeCheckbox={handleDeleteAll}
                         getActionsButtons={getActionsButtons}
                         handleCheckboxChange={handleCheckboxChange}
                         selectedList={selectedList}
            />

            {modalShow &&
                <AddDeviceModal
                    title={t('add')}
                    check='true'
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    item={item}
                    onAdded={() => setModified(true)}
                />
            }

            {showLogModal &&
                <DeviceLogModal
                    show={showLogModal}
                    onHide={() => setShowLogModal(false)}
                    data={logDevice}
                />
            }
            <RemoveModal
                show={deleteDeviceShow}
                onHide={() => {
                    setDeleteDeviceShow(false);
                    setSelectedList([]);
                }}
                data={selectedList}
                title_modal={"delete_devices"}
                title_modal_remove={'delete'}
                element_modal={"device_s"}
                onDelete={() => {
                    setModified(true);
                }}
            />
        </>
    );
};

export default TotalAccessService;
